export const PROPERTIES_TO_PRESERVE = ['type']
